import { useEffect, useRef, useMemo } from 'react';
import { withStore } from '@stores';
import { observer } from 'mobx-react-lite';
import clsx from 'clsx';

// Imports => Constants
import { TITLES } from '@constants';
import { ICONS, KEYS, THEMES, TYPES } from '@opp/ui-kit';

// Imports => Hooks
import { useUIActions } from '@hooks';

// Imports => Utilities
import { AcIsSet } from '@opp/ui-kit';

// Imports => Atoms
import {
  AcAvatarCard,
  AcHeading,
  AcRipple,
  AcIcon,
  AcIconButton,
  AcEmptyBlock,
} from '@opp/ui-kit';

const _CLASSES = {
  MAIN: 'ac-message-center',
  OPEN: 'ac-message-center--open',
  EMPTY: 'ac-message-center--empty',
  TOGGLE: {
    MAIN: 'ac-message-center__toggle',
    ICON: 'ac-message-center__toggle-icon',
    BADGE: 'ac-message-center__badge',
  },
};

const AcMessageCenter = ({ store: { ui } }) => {
  const { current_message_center } = ui;

  const $ref = useRef(null);

  const { handleClose, addEvents, removeEvents } = useUIActions(
    ui,
    KEYS.MESSAGE_CENTER,
    $ref
  );

  useEffect(() => {
    addEvents();

    return () => removeEvents();
  }, []);

  const getBadgeClassNames = useMemo(() => {
    return clsx(_CLASSES.TOGGLE.BADGE);
  }, []);

  const getToggleIconClassNames = useMemo(() => {
    return clsx(_CLASSES.TOGGLE.ICON);
  }, []);

  const getToggleClassNames = useMemo(() => {
    return clsx(_CLASSES.TOGGLE.MAIN);
  }, []);

  const getMainClassNames = useMemo(() => {
    return clsx(_CLASSES.MAIN, current_message_center.visible && _CLASSES.OPEN);
  }, [current_message_center.visible]);

  const renderMessagesCard = useMemo(() => {
    let title = '0 messages';
    let subtitle = 'No actions required';

    /*
        if (AcIsSet(current_messages) && current_messages.length > 0) {
            const count = current_messages.length;
            title = `${count} message${count === 1 ? '' : 's'}`;
            subtitle = `${count} message${count === 1 ? '' : 's'} need${
                count === 1 ? 's' : ''
            } attention`;
        }
        */

    return (
      <AcAvatarCard
        avatar={{ type: TYPES.ICON, value: ICONS.BELL_OUTLINE }}
        title={title}
        subtitle={subtitle}
        theme={THEMES.ECHO}
      />
    );
  }, []);

  const renderMessages = useMemo(() => {
    return (
      <AcEmptyBlock
        icon={ICONS.CELEBRATE}
        message={`You've read all your notifications from the last 30 days.`}
        border={false}
      />
    );
  }, []);

  return (
    <>
      <div className={'ac-off-canvas__section h-margin-y-0'}>
        <AcHeading
          rank={4}
          theme={THEMES.DARK}
          className={'h-margin-top-0 h-margin-bottom-20'}
        >
          <AcIconButton
            icon={ICONS.CLOSE}
            theme={THEMES.EGGWHITE}
            className={'h-margin-right-20'}
            callback={handleClose}
            flat={true}
            title={`Close ${TITLES.NOTIFICATIONS}`}
          />
          {TITLES.NOTIFICATIONS}
        </AcHeading>

        {renderMessagesCard}
      </div>

      <div
        className={
          'ac-off-canvas__section ac-off-canvas__section--flex h-padding-top-10 h-margin-top-0 h-margin-bottom-auto'
        }
      >
        {renderMessages}
      </div>
    </>
  );
};

export default withStore(observer(AcMessageCenter));
